/**
 * Filtros de colección
 * ---------------------------------------------------------------------------
 * Envía el formulario de filtros al cambiar cualquier control, en lugar de
 * obligar a pulsar "Aplicar".
 *
 * Se navega de verdad a la nueva URL (no se reemplaza el HTML por AJAX) para que
 * el estado del filtro quede en el historial y la URL sea compartible. Es más
 * lento que un intercambio parcial, pero es lo correcto para SEO y para el botón
 * de atrás del navegador, que es lo que la gente usa constantemente al filtrar.
 */

document.addEventListener('change', (event) => {
  const control = event.target.closest('[data-facet-auto-submit]');
  if (!control) return;

  // `control.form` respeta el atributo `form=`: el <select> de ordenación vive
  // fuera del formulario (los filtros están en la columna izquierda y la
  // rejilla no puede anidarse dentro de un <form>), pero pertenece a él.
  const form = control.form || control.closest('form');
  if (!form) return;

  const params = new URLSearchParams(new FormData(form));

  // Quita los parámetros vacíos para no ensuciar la URL
  for (const [key, value] of Array.from(params.entries())) {
    if (value === '') params.delete(key);
  }

  const query = params.toString();
  window.location.href = query
    ? `${window.location.pathname}?${query}`
    : window.location.pathname;
});
